import { render } from "./MutateEntity.vue?vue&type=template&id=035fe70c&scoped=true&ts=true"
import script from "./MutateEntity.vue?vue&type=script&lang=ts"
export * from "./MutateEntity.vue?vue&type=script&lang=ts"

import "./MutateEntity.vue?vue&type=style&index=0&id=035fe70c&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035fe70c"]])

export default __exports__